export const UPDATE_PROFILE = 'accountActions/UPDATE_PROFILE';
export const UPDATE_PROFILE_SUCCESS = 'accountActions/UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILED = 'accountActions/UPDATE_PROFILE_FAILURE';
export const UPDATE_STATUS = 'accountActions/UPDATE_STATUS';

export const CHANGE_PASSWORD = 'accountActions/CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'accountActions/CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILED = 'accountActions/CHANGE_PASSWORD_FAILED';

export function updateProfile(details) {
  return {
    type: UPDATE_PROFILE,
    details,
  };
}

export function updateProfileSuccess(user) {
  return {
    type: UPDATE_PROFILE_SUCCESS,
    user,
  };
}

export function updateProfileFailed(err) {
  return {
    type: UPDATE_PROFILE_FAILED,
    err,
  };
}

export function updateStatus() {
  return {
    type: UPDATE_STATUS,
  };
}

export function changePassword(details) {
  return {
    type: CHANGE_PASSWORD,
    details,
  };
}

export function changePasswordSuccess(user) {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    user,
  };
}

export function changePasswordFailed(err) {
  return {
    type: CHANGE_PASSWORD_FAILED,
    err,
  };
}
